var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.633 3.846a.75.75 0 00-.635 1.359 9.029 9.029 0 015.024 10.028c-1.006 4.895-5.805 8.058-10.701 7.055-2.371-.487-4.317-1.868-5.65-3.889a9.005 9.005 0 01-1.311-6.813 8.997 8.997 0 015.01-6.372.75.75 0 10-.641-1.356A10.484 10.484 0 00.89 11.284a10.497 10.497 0 001.527 7.94c1.554 2.356 3.837 3.966 6.601 4.534.7.144 1.413.216 2.127.216 4.91 0 9.32-3.448 10.345-8.44a10.524 10.524 0 00-5.858-11.688zM11.191 9.75a.75.75 0 00.75-.75V.75a.75.75 0 00-1.5 0V9c0 .414.336.75.75.75z",
    fill: "#fff",
    fillOpacity: 0.6
  })));
}
export default SvgIcLogout;